<template>
  <div class="benefits">
    <div
      v-for="(item, index) in benefits"
      :key="index"
      class="benefits-item"
    >
      <NuxtImg
        :src="item.icon"
        :alt="item.title"
      />
      <h2>{{ item.title }}</h2>
      <p>{{ item.description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      benefits: [
        {
          title: 'Grow your career',
          description:
            'We match you with companies using your favourite tech stacks, that need your capabilities, and actually want to work with you. Build your future now, not later.',
          icon: '/images/roles/hero/grow_your_career.svg',
        },
        {
          title: 'Remote only',
          description:
            'Gain a healthy work-life balance and access top remote positions at global companies, within +/- 4 hours of your timezone.',
          icon: '/images/roles/hero/remote_only.svg',
        },
        {
          title: 'Secure pay, every month',
          description:
            'Enjoy stable, competitive compensation through Deel with all full-time and part-time roles landed through Proxify. No more unpaid invoices or unexpected deductions.',
          icon: '/images/roles/hero/get_paid.svg',
        },
        {
          title: 'Talent support',
          description:
            'We’re dedicated to your success. Get help to unlock your true potential through webinars, personal career coaching, interview tips, and more.',
          icon: '/images/roles/hero/talent_support.svg',
        },
      ],
    };
  },
};
</script>

<style lang="scss" src="./BenefitsSection.scss" scoped />
